import axios from 'axios';
import Config from '../../../../Config';
import {creditCardData, isCreditCardError} from './PaymentSlice';
import {connect} from 'react-redux';
import {showAppLoader, hideAppLoader} from '../../../Shared/Loader/LoaderSlice';

export const getCreditCardToken = (props) => {
  const CreditCardInfo = {
    CardNumber: props.form.CardNumber,
    CardDueMonth: props.form.CardDueMonth,
    CardDueYear: props.form.CardDueYear,
    CVV: props.form.CVV,
    ID: props.form.id,
  };

  if (props.CCData.CCToken === undefined) {
    if (props.noLoader === undefined) {
      props.showAppLoader();
    }
    axios
      .post(Config.creditCardTokenUrl, {
        CreditCardInfo,
      })
      .then((result) => {
        if (result.data.CreditCardToken !== undefined) {
          props.isCreditCardError(false);
          const customerPaymentData = {
            CCToken: result.data.CreditCardToken,
            CCDueMonth: props.form.CardDueMonth,
            CCDueYear: props.form.CardDueYear,
            CCType: GetCreditCardTypeId(result.data.CreditCompanyCode),
            CCID: props.form.id,
          };

          props.creditCardData(customerPaymentData);
          if (props.noLoader === undefined) {
            props.hideAppLoader();
          }
        } else {
          props.isCreditCardError(true);
          props.hideAppLoader();
        }
      })
      .catch((error) => {});
  }
};

const GetCreditCardTypeId = (creditCardCompany) => {
  var ccType = '';
  if (typeof creditCardCompany != 'undefined' && creditCardCompany != null && creditCardCompany.length > 0) {
    switch (creditCardCompany.substring(0, 1)) {
      case '1':
        ccType = 'IS';
        break;
      case '2':
        ccType = 'VS';
        break;
      case '3':
        ccType = 'DY';
        break;
      case '4':
        ccType = 'AM';
        break;
      case '6':
        ccType = 'LC';
        break;
    }
  }

  return ccType;
};

const mapStateToProps = (state) => {
  return {CCData: state.Payment.CCData, CCError: state.Payment.CCError};
};

const mapDispatchToProps = {
  creditCardData,
  isCreditCardError,
  showAppLoader,
  hideAppLoader,
};

export default connect(mapStateToProps, mapDispatchToProps)(getCreditCardToken);
